import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { UniqueBukaHome } from './pages/UniqueBukaHome';
export function UniqueBukaApp() {
  return <Routes data-id="element-1381">
      <Route path="/" element={<UniqueBukaHome data-id="element-1383" />} data-id="element-1382" />
    </Routes>;
}